var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoyaltyBanner = function SvgLoyaltyBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.986 22a8.483 8.483 0 0 0-7.844 5.247 8.51 8.51 0 0 0 1.84 9.263 8.488 8.488 0 0 0 9.253 1.843 8.507 8.507 0 0 0 2.754-13.863A8.485 8.485 0 0 0 25.986 22Zm0 12.112a3.606 3.606 0 0 1-3.334-2.23 3.617 3.617 0 0 1 .783-3.936 3.607 3.607 0 0 1 6.16 2.554 3.616 3.616 0 0 1-2.228 3.337 3.604 3.604 0 0 1-1.381.275Z",
    fill: "url(#loyalty-banner_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M44.463 64c0 1.658-1.342 3-2.995 3a2.998 2.998 0 0 1-2.995-3c0-1.658 1.342-3 2.995-3a2.998 2.998 0 0 1 2.995 3Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m47.46 18.781 3.607.17L54.104 17l-.17 3.61 1.95 3.041-3.605-.17-3.038 1.953.17-3.61-1.95-3.042Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m0 16.348 1.948-1.774L2.51 12l1.772 1.948 2.573.56-1.948 1.774-.562 2.574-1.772-1.948L0 16.348Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m6.672 58.441 4.012-3.333 1.343-5.043 3.33 4.017 5.037 1.344-4.012 3.333-1.343 5.044-3.33-4.017-5.037-1.345ZM50.98 55.592l1.985-1.026 1.024-1.987 1.025 1.987 1.985 1.026-1.985 1.026-1.025 1.986-1.024-1.986-1.985-1.026Z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.478,
    cy: 10,
    rx: 1.998,
    ry: 2,
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 11.503,
    cy: 1,
    rx: 0.999,
    ry: 1,
    fill: "currentColor"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 34.975,
    cy: 47.5,
    rx: 1.498,
    ry: 1.5,
    fill: "currentColor"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 2.513,
    cy: 42,
    rx: 1.998,
    ry: 2,
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loyalty-banner_svg__a",
    x1: 20.503,
    y1: 22,
    x2: 30.436,
    y2: 25.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
};
export default SvgLoyaltyBanner;